import { NumberPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';

export default (): NumberPointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.NUMBER_POINTER,
  variable: null,
});
